<template>
  <div style="padding: 0 12px;">
    <div class="tab-selector">
      <div :class="{active:memberId===''}" @click="search()">
        <span><a-icon type="appstore" /> 全部</span>
        <span class="small">{{ albumStats["photo_total"] }} / {{ albumStats["photo_origin"] }}</span>
      </div>
      <template v-for="grapher in result.data">
        <div v-if="visible(grapher)"
             :class="{active:memberId===grapher.id}" :key="grapher.id" @click="search(grapher.id)">
          <span><a-icon type="user" /> {{ names[grapher.id] }}</span>
          <span>{{ photoTotal(grapher) }} / {{ photoOrigin(grapher) }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import api from "../../../../../utils/api";
import func from "../../../../../utils/func";
import cache from "../../../../../utils/cache";
import enums from "../../../../../utils/enums";

export default {
  name: "MemberPane",
  props: {
    album: Object,
    member: Object,
    albumStats: Object,
  },
  data() {
    return {
      result: {
        total: 0,
        data: [],
      },
      names: {},
      timeId: null,
      memberIds: [],
      memberStats: {},
    }
  },
  computed: {
    memberId() {
      return this.$attrs.value;
    },
  },
  async mounted() {
    this.names = await cache.v1.album.member.names(this.album.id, enums.Role.Grapher);
    this.result = await cache.v1.album.member.search(this.album.id);
    this.memberIds = func.getByKey(this.result.data, "id");
    this.restats(); // 刷新统计
  },
  destroyed() {
    clearTimeout(this.timeId);
  },
  methods: {
    refresh() {
      this.restats();
      this.$emit("search");
    },
    visible(grapher) {
      return enums.Role.isGrapher(grapher["roles"]) || this.photoTotal(grapher);
    },
    photoTotal(grapher) {
      return func.isDefined(this.memberStats[grapher.id]) ? this.memberStats[grapher.id]["photo_total"] : 0;
    },
    photoOrigin(grapher) {
      return func.isDefined(this.memberStats[grapher.id]) ? this.memberStats[grapher.id]["photo_origin"] : 0;
    },
    restats() {
      this.timeId && clearTimeout(this.timeId);
      api.v1.album.stats
          .member(this.album.id, this.memberIds.join(","))
          .then(res => this.memberStats = res);
      this.timeId = func.setTimeout(30000, this.restats);
    },
    search(id) {
      this.$emit("input", func.stringStrict(id));
      this.$emit("search"); // search after input
      this.restats() // restats when search
    }
  }
}
</script>

<style lang="less" scoped>
.tab-selector {
  font-size: 12px;
  margin: 10px -15px;
  overflow-x: hidden;
  overflow-y: auto;

  div {
    cursor: pointer;
    padding: 5px 15px;

    span:last-child {
      display: block;
      .anticon {
        margin-right: 6px;
      }
    }
  }

  .active {
    color: #1890ff;
  }
}
</style>
